<template>
  <v-row no-gutters justify="center">
    <dense-full-text-pdf-dropzone v-if="dense" v-model="file" />
    <full-text-pdf-uploader
      v-else
      v-model="file"
      class="flex-grow-1"
      :progress="progress"
      :page-level="pageLevel"
      @cancel="onCancel"
    />
  </v-row>
</template>

<script>
import DenseFullTextPdfDropzone from './DenseFullTextPdfDropzone';
import FullTextPdfUploader from './FullTextPdfUploader';
import { Reference } from '@/models';
import { mapActions, mapGetters } from 'vuex';

export default {
  name: 'UploadFullTextPdfController',
  components: { DenseFullTextPdfDropzone, FullTextPdfUploader },
  props: {
    reference: {
      type: Reference,
      required: true,
    },
    dense: {
      type: Boolean,
      default: false,
    },
    pageLevel: {
      type: Boolean,
      default: false,
    },
  },
  computed: {
    ...mapGetters({
      getProgress: 'fullTextPdf/progress',
      getFile: 'fullTextPdf/file',
    }),
    progress() {
      return this.getProgress(this.reference.id);
    },
    file: {
      get: function () {
        return this.getFile(this.reference.id);
      },
      set: function (file) {
        this.$emit('uploading');
        this.uploadFullTextPdf({
          reference: this.reference,
          file,
        });
      },
    },
  },
  methods: {
    ...mapActions({
      uploadFullTextPdf: 'fullTextPdf/upload',
      cancelFullTextPdfUpload: 'fullTextPdf/cancel',
    }),
    onCancel() {
      this.cancelFullTextPdfUpload(this.reference.id);
    },
  },
};
</script>
